import axios from 'axios';

export const getPois = (bounds, callback, errorcallback, cancelToken) => {
  const markerUrl = 'api/marker.png';
  const url = 'pois/get';

  axios
    .get(markerUrl, { cancelToken })
    .then((markerResponse) => {
      const vector = markerResponse.headers['x-cache-id'];
      const params = {
        bounds: JSON.stringify(bounds),
      };
      return axios.get(url, {
        params,
        cancelToken,
        headers: {
          'X-Map-Vector': vector,
        },
      });
    })
    .then((response) => {
      if (response.status === 200) {
        const pois = response.data;
        callback(pois);
      }
    })
    .catch((err) => {
      if (axios.isCancel(err)) {
        return;
      }
      errorcallback(err);
    });
};

export const getPoiById = (id, callback, errorcallback, cancelToken) => {
  const tokenUrl = 'api/marker.png';
  const url = `pois/get?id=${id}`;

  axios
    .get(tokenUrl, { cancelToken })
    .then((tokenResponse) => {
      const token = tokenResponse.headers['x-cache-id'];
      return axios.get(url, {
        cancelToken,
        headers: {
          'X-Map-Vector': token,
        },
      });
    })
    .then((response) => {
      if (response.status === 200) {
        const poi = response.data;
        callback(poi);
      }
    })
    .catch((err) => {
      if (axios.isCancel(err)) {
        return;
      }
      errorcallback(err);
    });
};

export const sendPoiRequest = ({
  poiId,
  fromDate,
  toDate,
  language,
  boatId,
  accountId,
  comment,
  callback,
  errorCallback,
}) => {
  axios
    .post('poi_requests/create', {
      poi_id: poiId,
      from_date: fromDate,
      to_date: toDate,
      language,
      boat_id: boatId,
      account_id: accountId,
      account_comment: comment,
    })
    .then((response) => {
      if (response.status === 200) {
        callback(response.data);
      }
    })
    .catch((err) => {
      errorCallback(err);
    });
};

export const increasePoiClicks = (poi_id, type, callback, errorcallback) => {
  const url = `pois/increase_counter`;
  const body = {
    poi_id: poi_id,
    type: type,
  };
  axios
    .post(url, body)
    .then((response) => {
      if (response.status === 200) {
        console.log('increasePoiClicks success: ', response.data);
        callback(response.data);
      }
    })
    .catch((err) => {
      errorcallback(err);
    });
};
